import { render, staticRenderFns } from "./BlogPostComponent.vue?vue&type=template&id=6cc89dfa&"
import script from "./BlogPostComponent.vue?vue&type=script&lang=ts&"
export * from "./BlogPostComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports